export default "__VITE_ASSET__wj_8VCsg__"